import React, { useEffect, useState } from "react";
import { MaskedHeading, Fade, FadeUp } from "@/components/Reveal";
import CaseCard from "@/components/CaseCard";
import { getCases } from "@/lib/api";
import usePageMeta from "@/lib/usePageMeta";

export default function Cases() {
  const [cases, setCases] = useState([]);
  usePageMeta({
    title: "Cases",
    description:
      "Se udvalgte projekter fra Hagelund — vinduer og døre, der har løftet hjemmet visuelt, funktionelt og værdimæssigt.",
    path: "/cases",
  });
  useEffect(() => {
    getCases().then(setCases).catch(() => {});
  }, []);

  return (
    <div data-testid="cases-page">
      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pt-36 md:pt-48 pb-16 md:pb-24">
        <Fade>
          <p className="text-xs uppercase tracking-label text-accent mb-6">Inspirationsunivers</p>
        </Fade>
        <h1 className="font-display font-light leading-[0.9] text-6xl md:text-9xl tracking-tight">
          <MaskedHeading lines={["Cases"]} delay={0.2} />
        </h1>
        <FadeUp delay={0.3}>
          <p className="mt-8 text-muted-foreground font-light text-lg max-w-2xl">
            Udvalgte projekter, hvor døre og vinduer har løftet hele hjemmet — visuelt, funktionelt og værdimæssigt.
          </p>
        </FadeUp>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 md:px-12 pb-32 md:pb-48">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12">
          {cases.map((c, i) => (
            <CaseCard key={c.id} item={c} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}
